import { OralReadingChartActions } from './oral-reading-chart.actions';

export const initialState = {};

export function reducer(state = initialState, action: OralReadingChartActions) {
    return state;
}
